import { render } from "./voiceItem.vue?vue&type=template&id=993aab8c"
import script from "./voiceItem.vue?vue&type=script&lang=js"
export * from "./voiceItem.vue?vue&type=script&lang=js"

import "./voiceItem.vue?vue&type=style&index=0&id=993aab8c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__